import { z } from 'zod';

export enum DateFormat {
  LocalDate = 'DD/MM/YYYY',
  LocalDateTime = 'DD/MM/YYYY HH:mm',
  LocalTime = 'HH:mm',
}

export const LocalDate = z.string().brand<'LocalDate'>();
export type LocalDate = z.infer<typeof LocalDate>;

export const LocalTime = z.string().brand<'LocalTime'>();
export type LocalTime = z.infer<typeof LocalTime>;

export const LocalDateTime = z.string().brand<'LocalDateTime'>();
export type LocalDateTime = z.infer<typeof LocalDateTime>;

export type DateTypes<Format extends DateFormat> = {
  [DateFormat.LocalDate]: LocalDate;
  [DateFormat.LocalDateTime]: LocalDateTime;
  [DateFormat.LocalTime]: LocalTime;
}[Format];
